// extracted by mini-css-extract-plugin
export default {"navMenu":"NavMenu_navMenu__rW-Up","modal-fadein":"NavMenu_modal-fadein__EZL9M","modal-flyin":"NavMenu_modal-flyin__A7sgS","modal-flyin-reverse":"NavMenu_modal-flyin-reverse__bXCfQ"};